export const companies = [
  {
    alphasearchId: "65f49fe09121f77f77b8d294",
    primaryName: "Luciola Solutions",
    alternativeNames: ["Luciola Solutions, LLC", "Luciola Solutions LLC"],
    primaryLocation: {
      fullAddress: "420 Summit Avenue, Suite 316, St. Paul, MN 55102",
      msa: "Minneapolis-St. Paul- Bloomington, MN-WI",
      county: "Ramsey County, MN",
      lat: 44.945840,
      long: -93.114134
    },
    otherLocations: [
      {
        fullAddress: "1531 State Route 29, HUNLOCK CREEK, PA 18621",
        msa: "Scranton - Wilkes-Barre, PA",
        county: "Luzerne County, PA",
        lat: 41.257193,
        long: -76.08882
      },
      {
        fullAddress: "378 Mount Curve Blvd, Saint Paul, MN 55105",
        msa: "Minneapolis-St. Paul- Bloomington, MN-WI",
        county: "Ramsey County, MN",
        lat: 44.945840,
        long: -93.114134
      },
    ],
    primaryTelephone: "+1 763 234 2183",
    alternateTelephones: ["+1 651 497 7478"],
    sourcedClassifications: [
      {
        levels:
          [
            {type: "NAICS", code: 54, description: "Professional, Scientific, and Technical Services", likelihood: -1},
            {type: "NAICS", code: 541, description: "Professional, Scientific, and Technical Services", likelihood: -1},
            {type: "NAICS", code: 5416, description: "Management, Scientific, and Technical Consulting Services", likelihood: -1},
            {type: "NAICS", code: 54169, description: "Other Scientific and Technical Consulting Services", likelihood: -1},
            {type: "NAICS", code: 541690, description: "Other Scientific and Technical Consulting Services", likelihood: -1},
          ]
      }
    ],
    modeledClassifications: [
      {
        levels:
          [
            {type: "NAICS", code: 23, description: "Construction", likelihood: 1},
            {type: "NAICS", code: 238, description: "Specialty Trade Contractors", likelihood: 1},
            {type: "NAICS", code: 2382, description: "Building Equipment Contractors", likelihood: 1},
            {type: "NAICS", code: 23821, description: "Electrical Contractors and Other Wiring Installation Contractors", likelihood: 1},
            {type: "NAICS", code: 238210, description: "Electrical Contractors and Other Wiring Installation Contractors", likelihood: 1}
          ]

      },
      {
        levels:
          [
            {type: "NAICS", code: 22, description: "Utilities", likelihood: 0.852253},
            {type: "NAICS", code: 221, description: "Utilities", likelihood: 0.51279395},
            {type: "NAICS", code: 2211, description: "Electric Power Generation, Transmission and Distribution", likelihood: 0.375138},
            {type: "NAICS", code: 22112, description: "Electric Power Transmission, Control, and Distribution", likelihood: 0.821550},
            // {type: "NAICS", code: 221121, description: "Electric Bulk Power Transmission and Control", likelihood: 0.63493}
          ]
      },
    ],
    bestClassification:
      {
        levels:
          [
            {type: "NAICS", code: 54, description: "Professional, Scientific, and Technical Services", likelihood: 0.852253},
            {type: "NAICS", code: 541, description: "Professional, Scientific, and Technical Services", likelihood: 0.852253},
            {type: "NAICS", code: 5416, description: "Management, Scientific, and Technical Consulting Services", likelihood: 0.51279395},
            {type: "NAICS", code: 54169, description: "Other Scientific and Technical Consulting Services", likelihood: 0.375138},
            {type: "NAICS", code: 541690, description: "Other Scientific and Technical Consulting Services", likelihood: 0.821550},
          ],
      },
    descriptive: [
      "Luciola Solutions is a provider of advanced technical consulting services to the investment management industry.\n" +
      "\n" +
      "Among other things, Luciola provides expertise in cutting-edge processes and techniques for portfolio construction and optimization, risk modeling and risk management, global macroeconomic and business cycle analysis, and methods for producing forecasts of assets’ expected returns. Learn how we can help you:"
    ],
    keywords: ["Portfolio Optimization", "Capital Market Assumptions", "Ex-Ante Risk & Tracking Error", "Exposures & Factor Analysis", "Return Attribution"],
    incorporation: {
      domicile: "Minnesota, United States",
      legalForm: "Limited Liability Company",
      marketability: "Private/Closely-Held",
      forProfit: true
    },
    primaryLogo: "https://www.luciola-im.com/assets/images/favicons/apple-touch-icon.png",
    alternateLogo: undefined,
    primaryWebsite: "solutions.luciola-im.com",
    alternateWebsites: undefined,
    socioeconomic: {
      hispanicOrLatino: undefined,
      female: false,
      veteran: true,
      minority: false,
      hubzone: false,
      lowOrModerateIncome: false,
      rural: false,
    },
    harmonizedHeadcount: {
      pointEstimate: 3.5,
      upperBound: 8.1,
      lowerBound: 1.3,
      dataPoints: [1.5, 1.2]
    },
    fteHeadcount: {
      pointEstimate: 2.1,
      upperBound: 6.6,
      lowerBound: 0.9,
      dataPoints: [1]
    },
    totalHeadcount: {
      pointEstimate: 4,
      upperBound: 11,
      lowerBound: 2.5,
      dataPoints: [2]
    },
    onlineHeadcount: {
      pointEstimate: 2.1,
      upperBound: 6.6,
      lowerBound: 0.9,
      dataPoints: [1]
    },
    revenue: {
      pointEstimate: 500000,
      upperBound: 1600000,
      lowerBound: 100000,
      dataPoints: []
    },
    revenuePerEmployee: {
      pointEstimate: 200000,
      upperBound: 315000,
      lowerBound: 75000,
      dataPoints: []
    },
    qualityScore: 30,
    people: [
      {email: "info@luciola-im.com"},
      {
        fullName: "Marco Perzichilli, CFA",
        firstName: "Marco",
        lastName: "Perzichilli",
        credential: "Chartered Financial Analyst (CFA)",
        title: "Founding Managing Principal",
        bio: "\n" +
          "Mr. Perzichilli founded Luciola Solutions in 2023 and serves as the primary engagement partner for all client relationships.\n" +
          "\n" +
          "Prior to founding Luciola Solutions, Marco founded and ran Luciola Investment Management, an incubating alternative asset manager developing systematic, global macro and cross-asset strategies, with applications in managed futures and long/short equity.\n" +
          "\n" +
          "Before Luciola Investment Management, Marco was a Senior Investment Logic Engineer at Bridgewater Associates, LP where he focused on building and implementing inputs to macroeconomic trading signals as well as developing algorithms relating to portfolio construction and automated trading.\n" +
          "\n" +
          "Before Bridgewater, Marco was a Senior Investment Director and head of Quantitative Analysis at Minneapolis-based Galliard Capital Management, which manages over $90B in taxable fixed-income. At Galliard, Marco contributed to a wide variety of research agendas and portfolio management activities while also directing the firm's global sovereign debt strategy. Also at Galliard, Marco led a build-out of the firm's proprietary risk management and portfolio management systems, including the development of novel and patent-protected systems for agent-based risk modeling of outcomes in interconnected financial domains.\n" +
          "\n" +
          "Earlier in his career, Marco worked in roles conducting appraisals of performance, risk, and other quantitative measures for institutional custody clients of both Wells Fargo & Co. and US Bank.\n" +
          "\n" +
          "Marco holds an M.S. in Finance from The Johns Hopkins University and a B.A. in Economics from the University of Minnesota. Marco has earned the right to use the Chartered Financial Analyst (CFA) designation.",
        phone: "+1 763 234 2183",
        email: "marco.perzichilli@luciola-im.com",
        imageUrl: "https://solutions.luciola-im.com/headshot.jpg"
      },
      {
        fullName: "Leigh Lommen",
        firstName: "Leigh",
        lastName: "Lommen",
        credential: undefined,
        title: "Senior Consultant",
        bio: "" +
          "Mr. Lommen joined Luciola Solutions in 2024. In addition to possessing a superb set of technical skills, Leigh brings with him a wealth of expertise in private markets and direct C-suite management experience. Apart from his engagements with Luciola, Leigh is presently active as a principal in both private equity and venture markets.\n" +
          "\n" +
          "Previously, Leigh founded and ran Parallax Quantitative Asset Management, a proprietary trading firm employing statistical arbitrage strategies. Prior to Parallax, Leigh was a Quantitative Researcher at Connors Research, where he worked on a team designing statistical arbitrage strategies for sale to third parties.\n" +
          "\n" +
          "Earlier in his career, Leigh was CFO and Controller for Courtesy Corporation, an operator of franchised restaurants in the Midwest. Leigh also worked as a futures and options trader for Chicago-area firms LOT, LLC and Futrex Trading, LLC.\n" +
          "\n" +
          "Leigh holds an MBA from Columbia University, a M.S. in Financial Mathematics from the University of Minnesota, and a B.A. in Finance from the University of Wisconsin.",
        phone: "+1 904-710-9583",
        email: "leigh.lommen@winterfellinvestments.com",
        imageUrl: "https://solutions.luciola-im.com/lommen_greyscale.jpg"
      }
    ],
    social:
      {linkedinUrl: "https://www.linkedin.com/company/luciola-solutions"},
    similarCompanies: [
      "66451584c614d89ed004e132", "66451584c614d89ed004e133", "66451584c614d89ed004e134", "66451584c614d89ed004e135",
      "66451584c614d89ed004e136", "66451584c614d89ed004e137", "66451584c614d89ed004e138", "66451584c614d89ed004e139",
      "66451584c614d89ed004e13a", "66451584c614d89ed004e13b"
    ],
    franchise: {
      franchiseName: "McDonalds"
    }
  },
  {
  "_id": {
    "$oid": "66c3c9de60a8549475a7da53"
  },
  "alphasearchId": "0x1592b4771f76fcf2",
  "alphasearchIdVariants": [
    "0x1592b4771f76fcf2"
  ],
  "stagedId": "6645158564d4d7e96204e16a",
  "primaryName": "BMW Manufacturing",
  "primaryTelephone": "+18648025546",
  "primaryLocation": {
    "fullAddress": "PO Box 11000, Spartanburg, South Carolina, 29304, United States",
    "fullStreet": "PO Box 11000",
    "streetNumber": null,
    "streetName": null,
    "streetType": null,
    "routeId": null,
    "postDirection": null,
    "floor": null,
    "buildingId": null,
    "occupancy": null,
    "city": "Spartanburg",
    "region1": "South Carolina",
    "postalCode": "29304",
    "countryId": "US",
    "isHq": false,
    "msa": null,
    "county": null,
    "lat": 34.916625,
    "long": -81.863874,
    "pointRFC7946": [
      -81.863874,
      34.916625
    ]
  },
  "sourcedClassifications": [
    {
      "levels": [
        {
          "type": "NAICS",
          "code": 33,
          "description": "Manufacturing",
          "likelihood": -1
        },
        {
          "type": "NAICS",
          "code": 336,
          "description": "Transportation Equipment Manufacturing",
          "likelihood": -1
        }
      ]
    }
  ],
  "modeledClassifications": [
    {
      "levels": [
        {
          "type": "NAICS",
          "code": 44,
          "description": "Retail Trade",
          "likelihood": 0.3611019064556069
        },
        {
          "type": "NAICS",
          "code": 441,
          "description": "Motor Vehicle and Parts Dealers ",
          "likelihood": 0.21517156568632245
        },
        {
          "type": "NAICS",
          "code": 4411,
          "description": "Automobile Dealers ",
          "likelihood": 0.11037148032579747
        },
        {
          "type": "NAICS",
          "code": 44111,
          "description": "New Car Dealers ",
          "likelihood": 0.2210187302765414
        },
        {
          "type": "NAICS",
          "code": "441110",
          "description": "New Car Dealers ",
          "likelihood": 0.5389915283745624
        }
      ]
    },
    {
      "levels": [
        {
          "type": "NAICS",
          "code": 72,
          "description": "Accommodation and Food Services",
          "likelihood": null
        },
        {
          "type": "NAICS",
          "code": 721,
          "description": "Accommodation",
          "likelihood": 0.003791104387642101
        },
        {
          "type": "NAICS",
          "code": 7211,
          "description": "Traveler Accommodation",
          "likelihood": 0.05385164371647473
        },
        {
          "type": "NAICS",
          "code": 72111,
          "description": "Hotels (except Casino Hotels) and Motels",
          "likelihood": 0.09703371884547003
        },
        {
          "type": "NAICS",
          "code": "721110",
          "description": "Hotels (except Casino Hotels) and Motels ",
          "likelihood": 0.05152616836078509
        }
      ]
    },
    {
      "levels": [
        {
          "type": "NAICS",
          "code": 48,
          "description": "Transportation and Warehousing",
          "likelihood": null
        },
        {
          "type": "NAICS",
          "code": 488,
          "description": "Support Activities for Transportation",
          "likelihood": 0.015351140762507121
        },
        {
          "type": "NAICS",
          "code": 4889,
          "description": "Other Support Activities for Transportation",
          "likelihood": 0.44959558433265895
        },
        {
          "type": "NAICS",
          "code": 48899,
          "description": "Other Support Activities for Transportation",
          "likelihood": 0.6227644700512525
        },
        {
          "type": "NAICS",
          "code": "488999",
          "description": "All Other Support Activities for Transportation ",
          "likelihood": 0.3647256976416383
        }
      ]
    },
    {
      "levels": [
        {
          "type": "NAICS",
          "code": 81,
          "description": "Other Services (except Public Administration)",
          "likelihood": 0.13147873633569984
        },
        {
          "type": "NAICS",
          "code": 811,
          "description": "Repair and Maintenance",
          "likelihood": 0.08911955935018027
        },
        {
          "type": "NAICS",
          "code": 8111,
          "description": "Automotive Repair and Maintenance",
          "likelihood": 0.024994728181261867
        },
        {
          "type": "NAICS",
          "code": 81111,
          "description": "Automotive Mechanical and Electrical Repair and Maintenance",
          "likelihood": 0.0591830808267361
        },
        {
          "type": "NAICS",
          "code": "811111",
          "description": "General Automotive Repair ",
          "likelihood": 0.04475660562301418
        }
      ]
    }
  ],
  "descriptive": [
    "About BMW Manufacturing Co., LLC - BMW Manufacturing Co., LLC is a subsidiary of BMW AG in Munich, Germany and is the global producer of the BMW X3 and X5 Sport..."
  ],
  "keywords": [
    "Motor Vehicles",
    "Manufacturing"
  ],
  "primaryLogo": "https://res.cloudinary.com/zoominfo-com/image/upload/w_70,h_70,c_fit/bmwmc.com",
  "primaryWebsite": "www.bmwmc.com",
  "harmonizedHeadcount": {
    "pointEstimate": 75833.017743705,
    "lowerBound": 45901.17058579294,
    "upperBound": 106885.47165454688,
    "dataPoints": []
  },
  "fteHeadcount": {
    "pointEstimate": 51361.61757335594,
    "lowerBound": 31088.81117938335,
    "upperBound": 72393.40965992786,
    "dataPoints": []
  },
  "totalHeadcount": {
    "pointEstimate": 144663.24885340157,
    "lowerBound": 87563.60567842776,
    "upperBound": 203900.6233014968,
    "dataPoints": [
      134682
    ]
  },
  "onlineHeadcount": {
    "pointEstimate": 31474.18680435748,
    "lowerBound": 19051.09489956771,
    "upperBound": 44362.382002216,
    "dataPoints": []
  },
  "qualityScore": 23,
  "similarCompanies": [
    "6645158564d4d7e96204e16a",
    "664515856f07091e1604e52d",
    "664515865e0a283f6504e4d9",
    "664515893271a1775a04f1aa",
    "6645158dc614d89ed0050892",
    "664515942a41fe7b35052171",
    "6645159564d4d7e9620525e3",
    "6645159566e54c48e7052697",
    "664515a8714a80cd190577ce",
    "664515a8fa90b9d931057769"
  ],
  "partition360": 89
}
  ,
  // ZoomInfo-projected document, spec 2026-09-23 §4/§5 (no modeledClassifications,
  // bounds-only revenue, 3-digit NAICS, object social, externalIds, six-field lifecycle).
  {
    stagedId: "5a3f9c2e7b1d4e6f8a9b0c1d",
    primaryName: "Acme Fabrication",
    primaryWebsite: "https://acme-fabrication.example/about",
    descriptive: ["Precision construction components."],
    keywords: ["Construction", "Manufacturing"],
    primaryLocation: {
      fullAddress: "12 Foundry Rd, Toledo, OH 43604",
      city: "Toledo",
      region1: "OH",
      postalCode: "43604",
      countryId: "US"
    },
    primaryTelephone: "+14195550142",
    // §5.1 LT_5M: lowerBound 0, upperBound 5,000,000, no pointEstimate ('<$5 Million').
    revenue: {bucket: "LT_5M", lowerBound: 0, upperBound: 5000000},
    // §5.2 11_50: label '11-50'.
    harmonizedHeadcount: {bucket: "11_50", lowerBound: 11, upperBound: 50},
    // §5.3: ZoomInfo NAICS are <=3 digits; descriptions come from the taxonomy (projector.py:471-475).
    sourcedClassifications: [
      {
        levels: [
          {type: "NAICS", code: 33, description: "Manufacturing", likelihood: -1},
          {type: "NAICS", code: 332, description: "Fabricated Metal Product Manufacturing", likelihood: -1}
        ]
      }
    ],
    bestClassification: {
      levels: [
        {type: "NAICS", code: 33, description: "Manufacturing", likelihood: -1},
        {type: "NAICS", code: 332, description: "Fabricated Metal Product Manufacturing", likelihood: -1}
      ]
    },
    social: {
      linkedinUrl: "https://www.linkedin.com/company/acme-fabrication",
      linkedinFollowers: 1200
    },
    externalIds: {zoominfo: "4242", zoominfoUrl: "https://www.zoominfo.com/c/acme-fabrication/4242"},
    lifecycle: {
      status: "active",
      lastSeenSnapshot: "zoominfo-2026-h1",
      lastSeenAt: "2026-06-30T23:59:59Z",
      missedSnapshots: 0,
      tombstonedAt: null,
      evidence: {absentFromSnapshot: null}
    },
    emails: []
  }
]

export const zoominfoCompany = companies[companies.length - 1];